// Timeout
export function debounce(fn, threshold) {
  var timeout;
  return function debounced() {
    if (timeout) {
      window.clearTimeout(timeout);
    }

    function delayed() {
      fn();
      timeout = null;
    }

    timeout = window.setTimeout(delayed, threshold || 100);
  };
} // Distinct function for arrays

export function distinct(value, index, self) {
  return self.indexOf(value) === index;
} // if [A, B] is subset of [A, B, C] return true

export function isSubsetOf(set, subset) {
  for (var i = 0; i < subset.length; i++) {
    var value = subset[i].substring(1);

    if (set.indexOf(value) !== -1) {
      return true;
    }
  }

  return false;
} // Function for creating the tree in order to split the applied filters correctly

export function isotopeFilters(filterGroups) {
  var combo = [];

  for (var prop in filterGroups) {
    var group = filterGroups[prop].values;

    if (!group.length) {
      continue;
    }

    if (!combo.length) {
      combo = group.slice(0);
      continue;
    }

    var nextCombo = [];

    for (var i = 0; i < combo.length; i++) {
      for (var j = 0; j < group.length; j++) {
        var item = combo[i] + group[j];
        nextCombo.push(item);
      }
    }

    combo = nextCombo;
  }

  return combo.join(',');
}